import RapidChoiceBase from 'es6/controllers/apps/quizzes/rapid-choice-base';

class RapidChoicePair extends RapidChoiceBase {
  constructor(itemPackage, ...args) {
    super(itemPackage, ...args);
    this._setQuizType('RapidChoicePair');
    this._setDistractor(itemPackage.distractors.response);
    this.recall = 'cue';
    this.recallPrompt = itemPackage.getText();
    this.answer = itemPackage.getTranslation();
  }
}

export default RapidChoicePair;
